const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];
export function getPriceElastColours(){
  const DISTINCT = ["#a6cee3", "#b2df8a", "#fb9a99", "#fdbf6f", "#cab2d6","#ffff99", "#1f78b4", "#33a02c", "#e31a1c", "#ff7f00"];

  return DISTINCT
}
export function getPriceElastConfig() {
  const groupsById = {


    cheeseburgers: {
        type: "price_elast",
        label: "Food: Cheeseburgers",
        fulltext: "A cheeseburger at a fast food restaurant",
        keys:[
            "consumer_price:cheeseburgers_expect:mean",
            "consumer_price:cheeseburgers_expens:mean",
            "consumer_price:cheeseburgers_tooexpens:mean"
        ],
         labels:{
            "consumer_price:cheeseburgers_expect:mean": "Expected price",
            "consumer_price:cheeseburgers_expens:mean": "Increase that would feel expensive",
            "consumer_price:cheeseburgers_tooexpens:mean": "Increase that would feel too expensive"
        },
      polarity: {
        "expect": "consumer_price:cheeseburgers_expect:mean",
        "expensive": "consumer_price:cheeseburgers_expens:mean",
        "tooexpensive": "consumer_price:cheeseburgers_tooexpens:mean",
      }
    },
  coffee: {
        type: "price_elast",
        label: "Drink: Coffee",
        fulltext: "A Coffee at a coffee shop chain",
        keys:[
            "consumer_price:coffee_expect:mean",
            "consumer_price:coffee_expens:mean",
            "consumer_price:coffee_tooexpens:mean"
        ],
         labels:{
            "consumer_price:coffee_expect:mean": "Expected price",
            "consumer_price:coffee_expens:mean": "Increase that would feel expensive",
            "consumer_price:coffee_tooexpens:mean": "Increase that would feel too expensive"
        },
      polarity: {
        "expect": "consumer_price:coffee_expect:mean",
        "expensive": "consumer_price:coffee_expens:mean",
        "tooexpensive": "consumer_price:coffee_tooexpens:mean",
      }
    },


  };


  return {  groupsById };
}

export function buildLabelColorMaps(groupsById) {
  const labels = {};
  const colors = {};
  let colorIdx = 0;
  for (const g of Object.values(groupsById)) {
    for (const k of g.keys) {
      labels[k] = (g.labels && g.labels[k]) || k;
      if (!colors[k]) {
        if (g.type === "likert") {
          // Use the special likert color function
          colors[k] = baseColorForLikertKey(g, k);
        } else {
          // Default color assignment
          colors[k] = DISTINCT[colorIdx % DISTINCT.length];
          colorIdx += 1;
        }
      }
    }
  }
  return { labels, colors };
}

export function aggregateWeighted(rows, keys, { rowKey, weight = "total", predicate = null } = {}) {
  const acc = Object.create(null);
  const zero = Object.fromEntries(keys.map(k => [k, 0]));

  for (const r of rows || []) {
    if (predicate && !predicate(r)) continue;
    const d = r[rowKey];
    if (!d) continue;
    const w = Number(r[weight] ?? 0);
    if (!acc[d]) acc[d] = { w: 0, sums: { ...zero } };
    acc[d].w += w;
    for (const k of keys) acc[d].sums[k] += Number(r[k] ?? 0) * w;
  }

  const out = {};
  for (const [d, { w, sums }] of Object.entries(acc)) {
    const values = {};
    for (const k of keys) values[k] = w > 0 ? (sums[k] / w) * 100 : 0;
    out[d] = { totalWeight: w, values };
  }
  return out;
}

// utils/demoFilters.js (or wherever you keep it)

// Returns a predicate that matches your dataset’s integer-coded fields
export function buildDemoPredicate({
    gender = null,     // 1=Men, 2=Women
    age = null,        // 1=18–34, 2=35–64, 3=65+
    ethnicity = null,  // 1..5
    party = null,      // 1..4
    education = null,  // 1=No degree, 2=Degree
  } = {}) {
    return (r) => {
      // NOTE: r.<field> should be numbers in your data rows
      if (gender != null && Number(r.gender) !== Number(gender)) return false;
      if (age != null && Number(r.age) !== Number(age)) return false;
      if (ethnicity != null && Number(r.ethnicity) !== Number(ethnicity)) return false;
      if (party != null && Number(r.party_reg) !== Number(party)) return false;
      if (education != null && Number(r.education) !== Number(education)) return false;
      return true;
    };
  }
  
  // If you want to show labels elsewhere:
  export const GENDER = [
    { value: null, label: "All" },
    { value: 1,    label: "Men" },
    { value: 2,    label: "Women" },
  ];
  
  export const AGE = [
    { value: null, label: "All" },
    { value: 1,    label: "18–34" },
    { value: 2,    label: "35–64" },
    { value: 3,    label: "65+" },
  ];
  
  export const ETHNICITY = [
    { value: null, label: "All" },
    { value: 1,    label: "White" },
    { value: 2,    label: "Black" },
    { value: 3,    label: "Hispanic" },
    { value: 4,    label: "Asian" },
    { value: 5,    label: "Other" },
  ];
  
  export const PARTY = [
    { value: null, label: "All" },
    { value: 1,    label: "Dem" },
    { value: 2,    label: "Rep" },
    { value: 3,    label: "Ind" },
    { value: 4,    label: "None" },
  ];
  
  export const EDU = [
    { value: null, label: "All" },
    { value: 1,    label: "No degree" },
    { value: 2,    label: "Degree" },
  ];
  

export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];


  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}

// Tab-as-config default export
export default {
  tab: "price_elast",
  label: "Price Elasticity",
  get metrics() { return getPriceElastConfig().groupsById; },
};
